import React from 'react';
import { Rating, Typography } from 'fronton-react';
import { TConfigurator } from '../../../../types';
import { NoPhoto } from '../no-photo';
import { CardWrapper, ContentWrapper } from '../styled';
import { useAnalytics } from '../hooks';
import { CardPrice } from '../card-price';
import { categoryCard, imgStyles, PoraWrap, StyledDiv } from './styled';
import { useConfiguratorRating } from './hooks';
import { poraPoraConfigurators } from 'pora-pora';
import { Percentage15, Percentage20, Percentage50 } from 'common/pora-pora-icons';

type InstallationCardProps = {
	configurator: TConfigurator;
	wide: boolean;
	position: number;
};

export const InstallationCard = ({ configurator, wide, position }: InstallationCardProps) => {
	const { name, pageUrl, price, imageUrl, measurementUnit, isPriceStatic, id } = configurator;
	const { ref, analyticsClickHandler } = useAnalytics(configurator);
	const { avgRating, ratingText, ratingClickHandler } = useConfiguratorRating({
		pageUrl,
		configurator,
		position,
	});

	const isPoraPora = poraPoraConfigurators.find(({ categoryId }) => categoryId === id);

	const Icon = () => {
		if (!isPoraPora) return null;
		switch (isPoraPora.discountPercentage) {
			case 15:
				return <Percentage15 />;
			case 20:
				return <Percentage20 />;
			case 50:
				return <Percentage50 />;
			default:
				return null;
		}
	};

	function calculatePriceWithDiscount(prevPrice = 0, discountPercentage = 0) {
		if (!price || !discountPercentage) return 0;
		const discountFactor = 1 - discountPercentage / 100;
		const discountedPrice = prevPrice / discountFactor;
		return Math.ceil(discountedPrice);
	}

	return (
		<CardWrapper
			ref={ref}
			href={`${pageUrl}/`}
			className={categoryCard}
			data-qa="card"
			onClick={analyticsClickHandler}
			wide={wide}
		>
			{isPoraPora && (
				<PoraWrap>
					<Icon />
				</PoraWrap>
			)}
			{imageUrl ? (
				<img
					src={imageUrl}
					alt={name}
					className={imgStyles}
					data-qa="card-photo"
					data-analyticsName="productPhotoLink"
				/>
			) : (
				<NoPhoto />
			)}
			<ContentWrapper>
				<StyledDiv>
					<Typography
						variant="s"
						size="body_short"
						as="h3"
						data-qa="card-name"
						data-analyticsName="productNameLink"
					>
						{name}
					</Typography>
					<Rating size="s" value={avgRating} hasLink onClick={ratingClickHandler}>
						{ratingText}
					</Rating>
				</StyledDiv>
				<CardPrice
					price={price}
					unit={measurementUnit}
					flexiblePrice={!isPriceStatic}
					mainPriceColor={isPoraPora ? 'secondary-red-primary' : undefined}
					oldPrice={calculatePriceWithDiscount(price, isPoraPora?.discountPercentage)}
				/>
			</ContentWrapper>
		</CardWrapper>
	);
};
